import { initializeApp } from "firebase/app";
import { 
  updateProfile, 
  getAuth, 
  signInWithEmailAndPassword, 
  onAuthStateChanged, 
  reauthenticateWithCredential,  
  EmailAuthProvider              
} from "firebase/auth";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBUpqxYsBxhEkyIEwVlJGRW5Jkqx5wQG5A",
  authDomain: "convey-7ed73.firebaseapp.com",
  projectId: "convey-7ed73",
  storageBucket: "convey-7ed73.firebasestorage.app",
  messagingSenderId: "1012373112183",
  appId: "1:1012373112183:web:3bc609107d5a373dfdcd72",
  measurementId: "G-R13BJSDXXF"
};

// Inicializar Firebase y Realtime Database
const app = initializeApp(firebaseConfig);

// Exportar las funciones necesarias
export { 
  app, 
  updateProfile, 
  getAuth, 
  signInWithEmailAndPassword, 
  onAuthStateChanged, 
  reauthenticateWithCredential,  
  EmailAuthProvider              
};
